import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { imgUrl } from "../../../lib/api";
import { Card } from "../AdminUI";
import { Badge, VARIANTS, fmtRome } from "./igUtils";

const TABS = [["queue", "Coda", ["draft", "scheduled", "processing"]], ["published", "Pubblicati", ["published"]], ["error", "Errori", ["error"]]];

export function QueueList({ posts, slots, onOpen, connected }) {
  const [tab, setTab] = useState("queue");
  const waiting = !connected && posts.some((p) => p.status === "scheduled");
  const statuses = TABS.find((t) => t[0] === tab)[2];
  const rows = posts.filter((p) => statuses.includes(p.status)).sort((a, b) => (a.scheduled_at || a.created_at).localeCompare(b.scheduled_at || b.created_at) * (tab === "published" ? -1 : 1));
  return (
    <Card data-testid="ig-queue">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex gap-1">
          {TABS.map(([k, l, st]) => <button key={k} type="button" onClick={() => setTab(k)} data-testid={`ig-tab-${k}`} className={`px-3 py-1.5 text-xs rounded border ${tab === k ? "bg-ink text-white border-ink" : "bg-white border-gray-200"}`}>{l} <span className="opacity-60">({posts.filter((p) => st.includes(p.status)).length})</span></button>)}
        </div>
        {slots?.length > 0 && <div className="text-[11px] text-stone">Prossimi slot liberi: {slots.slice(0, 3).map(fmtRome).join(" · ")}</div>}
      </div>
      {waiting && <div data-testid="ig-queue-waiting" className="mb-3 text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded p-2">I post programmati verranno pubblicati solo dopo il collegamento dell'account Instagram.</div>}
      {rows.length === 0 && <div className="text-sm text-stone" data-testid="ig-queue-empty">{tab === "queue" ? "Nessun post in coda. Genera una bozza dai contenuti qui sopra." : tab === "published" ? "Nessuna pubblicazione ancora registrata." : "Nessun errore."}</div>}
      <div className="divide-y divide-gray-100">
        {rows.map((p) => (
          <button type="button" key={p.id} onClick={() => onOpen(p)} data-testid={`ig-post-row-${p.id}`} className="w-full flex items-center gap-4 py-3 text-left hover:bg-cream/60 px-1 rounded">
            <img src={imgUrl(p.images[0]?.framed || p.images[0]?.src)} alt="" className="w-12 aspect-[4/5] object-cover rounded border border-gray-200" />
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{p.title} <span className="text-stone text-xs">· {VARIANTS[p.variant]} · {p.images.length} img{p.auto ? " · automatico" : ""}</span></div>
              <div className="text-[11px] text-stone truncate">
                {p.status === "published" ? `Pubblicato ${fmtRome(p.published_at)}` : p.scheduled_at ? `Programmato ${fmtRome(p.scheduled_at)}` : `Creato ${fmtRome(p.created_at)}`}
                {p.last_error && <span className="text-red-700"> · {p.last_error}</span>}
              </div>
            </div>
            {p.permalink && <a href={p.permalink} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="text-xs underline inline-flex items-center gap-1 shrink-0">Instagram <ExternalLink size={11} /></a>}
            <Badge status={p.status} />
          </button>
        ))}
      </div>
    </Card>
  );
}
